import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logos/tree-crossing-logo-160h.png'
import _imports_1 from '@/assets/icons/green_check_circle_64.png'


const _withScopeId = n => (_pushScopeId("data-v-5be5973d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-code-page container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "Tree Crossing logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Quick sign in", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "status",
  alt: "Success"
}, null, -1))
const _hoisted_5 = { key: 2 }

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTokenManager } from './TokenManager'
import { useTelemetry } from '@/util/Telemetry'
import { LocalTokenApi } from './LocalTokenApi'
import { usePageTitle } from '@/util/AppUtil'
import { addRedactRule } from '@webapp/util/RedactRules'
import Spinner from '@/util/Spinner.vue'

const clientIdArg = 'client_id'
const tokenArg = 'approval_token'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceCodePage',
  setup(__props) {

const clientInfos = [
  { id: 'QhHfdp2TGc', name: 'Sync app' },
]

const busyRef = ref(false)
const approvedRef = ref(false)

const route = useRoute()
const router = useRouter()
const tokenManager = useTokenManager()
const { trackException } = useTelemetry()

usePageTitle('Quick sign in')
addRedactRule({ pattern: new RegExp(route.path), params: [tokenArg] })

const clientIdRef = computed(() => route.query[clientIdArg] as string)
const tokenRef = computed(() => route.query[tokenArg] as string)
const clientInfoRef = computed(() => clientInfos.find(n => n.id == clientIdRef.value))
const clientNameRef = computed(() => clientInfoRef.value?.name ?? 'app')

onMounted(async () => {
  approvedRef.value = false

  if (tokenManager.current.isValid) {
    try {
      busyRef.value = true
      await LocalTokenApi.approveDeviceCodeAsync(clientIdRef.value, tokenRef.value, tokenManager.current.token)
      approvedRef.value = true
    }
    catch (error) {
      trackException(error)
    }
    finally {
      busyRef.value = false
    }
  } 
  else {
    // Not signed in yet -- redirect to sign in page
    router.push({ path: '/signin', query: { redirect_uri: `${route.path}?${clientIdArg}=${clientIdRef.value}&${tokenArg}=${tokenRef.value}` } })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (busyRef.value)
      ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
      : (approvedRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_4,
            _createElementVNode("div", null, " You should now be signed in to the " + _toDisplayString(clientNameRef.value) + ". ", 1)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, " Approval failed :( "))
  ]))
}
}

})